<template>
  <div v-if="Lib.checkPower('beauty-2-yykb',2)">
    <div class="orderStatus">
      <!-- <p>
        <span></span>
        <label>已开单</label>
      </p> -->
      <p>
        <span></span>
        <label>待确认</label>
      </p>
      <p>
        <span></span>
        <label>已预约</label>
      </p>
      <p>
        <span></span>
        <label>预约超时</label>
      </p>
      <p>
        <span></span>
        <label>已开单</label>
      </p>
      <p>
        <span></span>
        <label>已取消</label>
      </p>
      <p>
        <span></span>
        <label>不可约</label>
      </p>
      <i class="iconfont screen" @click="display = true">&#xe63f;</i>
    </div>
    <drawer title="预约看板筛选" :display.sync="display" :set-icon="true" :display-set.sync="setShow">
      <div class="li">
        <p>选择日期</p>
        <el-button v-for="(v,n) in date" :key="n" size="small" :type="chooseDateVal == n ? 'primary' : ''" @click="clickDate(n)">{{ v }}</el-button>
        <el-date-picker v-model="chooseTime" size="small" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" :editable="false" :clearable="false" @change="getTable('choose')"></el-date-picker>
      </div>
      <div class="li">
        <p>时间间隔</p>
        <el-button size="small" :type="timeSpan == '15' ? 'primary' : ''" @click="chooseTimeSpan('15')">15min</el-button>
        <el-button size="small" :type="timeSpan == '30' ? 'primary' : ''" @click="chooseTimeSpan('30')">30min</el-button>
        <el-button size="small" :type="timeSpan == '60' ? 'primary' : ''" @click="chooseTimeSpan('60')">60min</el-button>
      </div>
      <div class="dfoot" @click="infoReset(0)">重置</div>
    </drawer>
    <!--5.6新增默认设置-->
    <drawer title="预约看板筛选-默认设置" :display.sync="setShow">
      <div class="li">
        <p>以下选项可更改默认设置，更改保存后，刷新页面生效！</p>
      </div>
      <div class="li">
        <p>时间间隔</p>
        <el-button size="small" :type="timeSpanTow == '15' ? 'primary' : ''" @click="chooseTimeSpanTow('15')">15min</el-button>
        <el-button size="small" :type="timeSpanTow == '30' ? 'primary' : ''" @click="chooseTimeSpanTow('30')">30min</el-button>
        <el-button size="small" :type="timeSpanTow == '60' ? 'primary' : ''" @click="chooseTimeSpanTow('60')">60min</el-button>
      </div>
      <ul class="drawer_foot">
        <li class="drawer_btn" @click="infoReset(1)">重置默认</li>
        <li class="drawer_btn_tow" @click="infoSave">更改默认</li>
      </ul>
    </drawer>
    <el-table id="bespeakTable" ref="bespeak_table" v-loading="loading" border tooltip-effect="light" element-loading-text="数据努力加载中，请稍等..." :data="tableData" :header-row-style="{height:'87.9px'}" align="center" :row-style="{height:'104px'}" :max-height="bespeakTableHeight" header-row-class-name="bespeakTable" :span-method="arraySpanMethod" class="bespeakFive">
      <el-table-column fixed prop="technicianName" label="姓名/日期" width="172" align="center">
        <template slot-scope="scope">
          <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
            <div slot="content">
              <p>{{ scope.row.technicianName }}</p>
            </div>
            <div class="textShow" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.technicianName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column v-for="(item,index) in timeList" :key="index" :label="`${item.beginTime} - ${item.endTime}`" align="center" width="172">
        <template slot-scope="scope">
          <div v-if="scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS.length == 1" class="customer_box">
            <div :class="'el-dropdown-link customer '+ (scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS[0].status == '待结算' ? 'four' : scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS[0].status == '待确认' ? 'two' : scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS[0].status == '已预约' ? 'three' : scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS[0].status == '已结算' ? 'four' : scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS[0].status == '到点超时' ? 'five' : 'six') + (scope.row.bookOrderTimeDTOS[index].irreducible == 1 ? ' newNum' : '')" @click="bespeakDetailsTwo(scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS[0].bookOrderId)">{{ scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS[0].name }}</div>
          </div>
          <div v-if="scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS.length > 1" class="customer_box" @click="irreducibleStatus ? addBespeak(scope.row.technicianId,scope.row.technicianName,item,scope.$index,index) : bespeakDetails(scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS)">
            <div :class="(scope.row.bookOrderTimeDTOS[index].irreducible == 1 ? 'newNum ' : '') + boxColorStatus(scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS)">
              <span class="span">{{ scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS.length }}</span>
            </div>
          </div>
          <div v-if="scope.row.bookOrderTimeDTOS[index].bookOrderDtailsDTOS.length == 0" :id="scope.$index+''+index" :class="(scope.row.bookOrderTimeDTOS[index].irreducible == 1 ? 'newNum ' : '')+'customer_box addBespeakHover'" @mouseover="hoverMouseover(scope.$index,index,scope.row.bookOrderTimeDTOS[index].irreducible,scope.row)" @mouseout="hoverMouseout(scope.$index,index)" @click="addBespeak(scope.row.technicianId,scope.row.technicianName,item,scope.$index,index)"><span></span><samp></samp></div>
        </template>
      </el-table-column>
    </el-table>

    <div class="orderFoot">
      <i v-if="!irreducibleStatus" @click="setIrreducible">&#xe63f;</i>
      <span v-if="!irreducibleStatus" @click="setIrreducible">设置不可约时间</span>
      <el-button v-if="irreducibleStatus" size="medium" style="margin-left: 30px;" type="primary" @click="saveSet">保存</el-button>
      <el-button v-if="irreducibleStatus" size="medium" @click="cancelSet">取消</el-button>
      <samp v-if="irreducibleStatus">直接点击看板设置不可约时间，再次点击可取消设置</samp>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="560px" :append-to-body="true">
      <span v-show="diaStatus === 2">确定要取消这条预约吗？</span>
      <span v-show="diaStatus === 0">确认要拒绝这条预约订单吗？</span>
      <p v-if="cancelStatus == 0">已超过预约可退定金时间，若顾客已支付定金/使用了划扣次数，取消订单后，定金/划扣次数将<samp class="themeFC">不会</samp>退回顾客</p>
      <p v-if="cancelStatus == 1">若顾客已支付定金/使用了划扣次数，{{ diaStatus == 2 ? '取消' : '拒绝' }}订单后，定金/划扣次数将退回顾客</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfirmCancelBespeak">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'预约详情-'+(chooseTechnicianName || ('未分配'+Lib.collectively()))" :visible.sync="bespeakDetailsDialog" width="1000px" :append-to-body="true">
      <h5 style="font-size: 14px;padding-bottom: 20px;">预约日期：{{ chooseDate }}<el-button style="float: right;margin-top: -13px;" type="primary" @click="detailAddBespeak">新增预约</el-button></h5>
      <el-table tooltip-effect="light" :data="chooseData" style="margin-bottom: 22px;">
        <el-table-column prop="dataTime" label="预约时间" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.dataTime }}({{ scope.row.serviceTime }}分钟)</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="顾客姓名" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.phone ? Lib.starPhone(scope.row.phone) : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="itemName" label="预约项目" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="technicianName" :label="'预约'+Lib.collectively()" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span style="line-height: 28px;">{{ scope.row.technicianName || '到店安排' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusCode" label="状态" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :style="Lib.getBespeakVal(scope.row.statusCode,2)">{{ Lib.getBespeakVal(scope.row.statusCode,1) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-button size="mini" plain @click="bespeakDetailsTwo(scope.row.bookOrderId)">详情</el-button>
            <el-button v-if="scope.row.status == '已预约' || scope.row.status == '到点超时'" size="mini" plain @click="handleCommand({name: '开单',item: scope.row})">开单</el-button>
            <el-button v-if="scope.row.status == '已开单'" size="mini" plain @click="handleCommand({name: '结算',item: scope.row})">结算</el-button>
            <el-button v-if="scope.row.status == '已预约' || scope.row.status == '到点超时'" size="mini" @click="handleCommand({name: '修改',item: scope.row})">修改</el-button>
            <el-button v-if="scope.row.status == '待确认'" size="mini" @click="handleCommand({name: '确认',item: scope.row})">确认</el-button>
            <el-button v-if="scope.row.status == '待确认'" size="mini" @click="handleCommand({name: '拒绝',item: scope.row})">拒绝</el-button>
            <el-button v-if="scope.row.status == '已预约' || scope.row.status == '到点超时'" size="mini" @click="handleCommand({name: '取消',item: scope.row})">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog class="yyDetails" title="预约详情" :visible.sync="detailsVisible" width="560px" :append-to-body="true">
      <div class="yyTop">
        <i class="iconfont" :style="(detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4 || detailsInfo.status == 2) ? 'color: #67C23A;' : 'color: #C4C0C0'">{{ (detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4) ? '&#xe65e;' : ( detailsInfo.status == 2) ? '&#xe767;' : '&#xe65f;' }}</i>
        <span>{{ (detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4) ? '已预约' : ( detailsInfo.status == 2) ? '已完成' : '已取消' }}</span>
        <samp :style="(detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4) ? 'color: #FA5555;' : 'color: #999;'">{{ detailsInfo.status == 0 ? '待服务' : detailsInfo.status == 1 ? '服务中' : detailsInfo.status == 3 ? '预约超时' : detailsInfo.status == 4 ? '待确认' : detailsInfo.status == -1 ? '商家取消' : detailsInfo.status == -2 ? '预约过期' : detailsInfo.status == -3 ? '用户取消' : detailsInfo.status == -4 ? '商家拒绝' : '' }}</samp>
      </div>
      <div class="yyInfoTitle">
        <span class="sl"></span>
        <span class="sm">预约信息</span>
      </div>
      <div class="yyInfo">
        <p>
          <span>姓名：</span>
          <samp>{{ detailsInfo.memberName }}</samp>
        </p>
        <p>
          <span>联系电话：</span>
          <samp>{{ detailsInfo.phone }}</samp>
        </p>
        <p>
          <span>预约时间：</span>
          <samp>{{ detailsInfo.bookDateTime }}</samp>
        </p>
        <p>
          <span>预约项目：</span>
          <samp>{{ detailsInfo.bookItemName }}</samp>
        </p>
        <p>
          <span>预约{{ Lib.collectively() }}：</span>
          <samp>{{ detailsInfo.bookTechnicianName }}</samp>
        </p>
        <p>
          <span>服务时长：</span>
          <samp>{{ detailsInfo.serviceTime }}分钟</samp>
        </p>
        <p>
          <span>备注：</span>
          <samp>{{ detailsInfo.remark || '--' }}</samp>
        </p>
      </div>
      <div class="yyInfoTitle">
        <span class="sl"></span>
        <span class="sm">其他信息：</span>
      </div>
      <div class="yyInfo">
        <p>
          <span>下单时间：</span>
          <samp>{{ detailsInfo.orderTime }}</samp>
        </p>
        <p>
          <span>来源：</span>
          <samp>{{ detailsInfo.orderSource }}</samp>
        </p>
        <p>
          <span>操作人：</span>
          <samp>{{ detailsInfo.dutyName }}</samp>
        </p>
        <h5 v-if="detailsInfo.orderCode">
          <span>订单号码：</span>
          <samp>{{ detailsInfo.orderCode }}</samp>
          <i class="el-icon-arrow-right" @click="lookOrder(detailsInfo.orderId,detailsInfo.orderType,detailsInfo.orderStatus,detailsInfo)"></i>
          <label @click="lookOrder(detailsInfo.orderId,detailsInfo.orderType,detailsInfo.orderStatus,detailsInfo)">查看订单</label>
        </h5>
      </div>
      <div v-if="(detailsInfo.status == -1 || detailsInfo.status == -2 || detailsInfo.status == -3 || detailsInfo.status == -4)" class="yyInfoTitle">
        <span class="sl"></span>
        <span class="sm">取消信息：</span>
      </div>
      <div v-if="(detailsInfo.status == -1 || detailsInfo.status == -2 || detailsInfo.status == -3 || detailsInfo.status == -4)" class="yyInfo">
        <p>
          <span>取消时间：</span>
          <samp>{{ detailsInfo.cancelTime }}</samp>
        </p>
        <p>
          <span>取消原因：</span>
          <samp>{{ detailsInfo.cancelCase }}</samp>
        </p>
      </div>
      <div class="yyFoot">
        <div v-if="detailsInfo.status == 0 || detailsInfo.status == 3">
          <el-button type="primary" @click="handleCommand({name: '开单',item: {bookOrderId: detailsInfo.orderId}})">开单</el-button>
          <el-button type="primary" @click="handleCommand({name: '修改',item: {bookOrderId: detailsInfo.orderId, technicianName: detailsInfo.bookTechnicianName == '到店安排' ? '' : detailsInfo.bookTechnicianName}})">修改</el-button>
          <el-button type="primary" @click="handleCommand({name: '取消',item: {bookOrderId: detailsInfo.orderId}})">取消</el-button>
        </div>
        <div v-else-if="detailsInfo.status == 4">
          <el-button type="primary" @click="handleCommand({name: '确认',item: {bookOrderId: detailsInfo.orderId}})">确认</el-button>
          <el-button type="primary" @click="handleCommand({name: '拒绝',item: {bookOrderId: detailsInfo.orderId}})">拒绝</el-button>
        </div>
        <div v-else-if="detailsInfo.status == 1">
          <el-button type="primary" @click="handleCommand({name: '结算',item: {orderId: detailsInfo.orderId}})">结算</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="'订单号-'+orderCode+'--'+orderTypeName" :visible.sync="orderDeatilsDialog" :append-to-body="true" width="1000px">
      <yzOrderDeatils :order-deatils-data="orderDeatilsData" :order-deatils-dialog="orderDeatilsDialog" :loading="loading2" @newGetListData="newGetListData" @tansferDialog="getDialogData" />
    </el-dialog>
  </div>
  <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
</template>

<script>
import dayjs from 'dayjs';
import DfSocket from 'df-plugins/src/socket/index.js';
import {
  getBookFailures,
  getBookOrders,
  getSureOrFalse,
  batchSetNoBookTime,
  getBookCancelMsg,
  saveOrUpdateEntry,
  queryEntryByMainId,
  getToken,
  getBookOrderDetail,
  // getOrderDetail4AllDto
} from './api/index.js';
import yzOrderDeatils from '../../stage/template/orderDetails/index';
import drawer from '../drawer';

export default {
  components: {
    drawer,
    yzOrderDeatils
  },
  data() {
    return {
      selectObject: {}, // 选中的值
      setShow: false, // 是否显示默认设置
      display: false,

      chooseTime: '', // 选择查找的单天预约时间
      loading: true, // 单天预约列表预加载参数
      tableData: [], // 单天预约列表数据
      timeList: [], // 表头数据列表
      dialogVisible: false, // 取消预约弹出窗口
      bespeakStatus: '', // 当天预约状态（0有预约  -1无预约）
      socketStartTime: '', // socket监听到的预约开始时间
      socketTechnicianId: '', // socket监听到的预约统称ID
      bespeakTableHeight: window.innerHeight - 270,

      chooseDate: '', // 选择的详情日期
      chooseTechnicianName: '', // 选择的详情统称名称
      chooseData: [], // 选择的详情数据
      bespeakDetailsDialog: false, // 详情弹框
      timeSpan: '15', // 时间间隔
      timeSpanTow: '15', // 设置-时间间隔
      tooltipStatus: false, // 气泡显示
      pageNum: 1,
      is_submit: false,

      mouseVal: '',
      mouseIndex: '',
      mouseStatus: 1,
      irreducibleStatus: false, // 设置不可约状态  false待定  true设置中
      chooseNoBook: [], // 选择的不可约的数据
      chooseId: '', // 取消预约的ID
      diaStatus: 3, // 弹出窗口文案提示状态
      cancelStatus: 1, // 取消预约退不退定金

      // 6.6
      date: ['今日', '明日', '后天'],
      chooseDateVal: 0,
      detailsVisible: false,
      detailsInfo: {},
      orderDeatilsDialog: false,
      orderCode: '',
      orderTypeName: '', // 订单类型名称
      orderDeatilsData: {
        itemList: [],
        payTypeList: []
      },
      loading2: true,
    };
  },
  mounted() {
    const vm = this;
    if (sessionStorage.getItem('token')) {
      const socketOptions = {
        scene: `/push?scene=1&tags=beauty-${sessionStorage.getItem('mainId')}&token=${sessionStorage.getItem('token')}`,
        messageTags: [`beauty-${sessionStorage.getItem('mainId')}`],
        message(sdata) {
          vm.callback(sdata.payload);
        }, // socket推送的数据
        connect() {},
        disconnect() {}, // 连接断开
        reconnectFailed() {}, // 重连失败
        error() {}, // 连接失败错误信息
      };
      new DfSocket(socketOptions).start(); // 开始连接
    } else {
      getToken().then((res) => {
        const socketOptions = {
          scene: `/push?scene=1&tags=beauty-${sessionStorage.getItem('mainId')}&token=${res.data}`,
          messageTags: [`beauty-${sessionStorage.getItem('mainId')}`],
          message(sdata) {
            vm.callback(sdata.payload);
          }, // socket推送的数据
          connect() {},
          disconnect() {}, // 连接断开
          reconnectFailed() {}, // 重连失败
          error() {}, // 连接失败错误信息
        };
        new DfSocket(socketOptions).start(); // 开始连接
      });
    }
  },
  // 获取当天时间，再请求当天预约列表数据
  activated() {
    if (this.mouseStatus == 2) {
      $(`#${this.mouseVal}${this.mouseIndex}`).text('');
      this.mouseStatus = 1;
    }
    this.chooseTime = this.Lib.G(1, 'yyyy-MM-dd');
    this.is_submit = false;
    this.pageNum = 1;
    this.getQueryEntryByMainId();
    // this.getTable();
    // //监听滚动
    // let tempLeft = 0;
    // this.$refs.bespeak_table.bodyWrapper.addEventListener(
    //   "scroll",
    //   res => {
    //     let height = res.target;
    //     let clientHeight = height.clientHeight;
    //     let scrollTop = height.scrollTop;
    //     let scrollHeight = height.scrollHeight;
    //     // 当滚动到底部 而且 不是水平滚动的时候
    //     if (clientHeight + scrollTop === scrollHeight && tempLeft === res.target.scrollLeft) {
    //       setTimeout(() => {
    //         this.getTable();
    //       }, 200);
    //     }
    //     tempLeft = res.target.scrollLeft;
    //   },
    //   true
    // );
    // this.getTimeList(15);
  },
  methods: {
    init() {
      this.getTable();
      // 监听滚动
      let tempLeft = 0;
      this.$refs.bespeak_table.bodyWrapper.addEventListener(
        'scroll',
        (res) => {
          const height = res.target;
          const { clientHeight } = height;
          const { scrollTop } = height;
          const { scrollHeight } = height;
          // 当滚动到底部 而且 不是水平滚动的时候
          if (clientHeight + scrollTop === scrollHeight && tempLeft === res.target.scrollLeft) {
            setTimeout(() => {
              this.getTable();
            }, 200);
          }
          tempLeft = res.target.scrollLeft;
        },
        true
      );
    },
    // 调用公共组件--赋值
    getDialogData(list) {
      this.orderDeatilsDialog = list;
    },
    // 子父组件赋值
    newGetListData() {
      this.getListData();
      this.$emit('getDelStatus', true);
    },
    // 查看订单
    // lookOrder(orderId, orderType, status) {
    //   const data = {
    //     id: orderId,
    //     orderType: 6
    //   };
    //   this.loading2 = true;
    //   this.orderDeatilsDialog = true;
    //   this.orderTypeName = this.Lib.getOrderTypeName(orderType);
    //   getOrderDetail4AllDto(data).then((res) => {
    //     if (res.code === 0) {
    //       res.data.itemList = res.data.itemList ? res.data.itemList : [];
    //       res.data.giftItemList = res.data.giftItemList ? res.data.giftItemList : [];
    //       res.data.giftItemList.forEach((a) => {
    //         a.isGift = a.activityId ? a.activityType == 3 ? 2 : a.activityType == 4 ? 3 : 1 : 1;
    //       });
    //       res.data.itemList = res.data.itemList.concat(res.data.giftItemList);
    //       res.data.itemList.forEach((a) => {
    //         // a.refundType = a.refundType === null
    //         a.refundNum = '0';
    //         a.refundCount = '0';
    //         a.refundMoney = a.resultPrice;
    //       });
    //       res.data.newStatus = status;
    //       res.data.refundStatus = res.data.refundStatus ? res.data.refundStatus : 0;
    //       this.orderDeatilsData = res.data;
    //       this.orderCode = res.data.dtoList ? res.data.dtoList.orderCode : res.data.orderCode;
    //       this.loading2 = false;
    //     }
    //   });
    // },
    // 查看订单
    lookOrder(orderId, orderType, status, v) {
      window.sessionStorage.orderData = window.JSON.stringify(v);
      this.$router.push({
        name: 'stage-orderDeatilsData',
        params: {
          orderId: v.orderId,
          orderType: v.orderType
        }
      });
    },
    setIrreducible() {
      this.irreducibleStatus = true;
    },
    // 获取-查询列表设置功能
    getQueryEntryByMainId() {
      const data = {
        mainId: sessionStorage.getItem('mainId'),
        pageType: 14,
        pageStyle: 1
      };
      queryEntryByMainId(data).then((res) => {
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.selectObject = res.data[0];
            this.timeSpanTow = res.data[0].entryName;
            this.timeSpan = res.data[0].entryName;
          } else {
            this.selectObject = {
              entrySite: 0, entryName: '15', mainId: sessionStorage.getItem('mainId'), pageStyle: 1, pageType: 14, status: 1,
            };
          }
          this.init();
        }
      });
    },
    // 保存修改的接口
    saveOrUpdateEntry() {
      const data = [this.selectObject];
      saveOrUpdateEntry(data).then((res) => {
        if (res.code == 0) {
          this.getQueryEntryByMainId();
          this.$message({
            message: '更改默认设置成功！',
            type: 'success'
          });
        }
      });
    },
    // 0是重置筛选，1是重置默认
    infoReset(type) {
      if (type == 0) {
        this.chooseTime = '';
        this.timeSpan = '15';
        this.getTable();
      } else {
        this.timeSpanTow = '15';
        this.selectObject.entryName = '15';
        this.saveOrUpdateEntry();
      }
    },
    // 更改默认
    infoSave() {
      this.saveOrUpdateEntry();
    },
    // 选择设置时间
    chooseTimeSpanTow(val) {
      this.timeSpanTow = val;
      this.selectObject.entryName = val;
    },
    // 预约面板颜色判断
    boxColorStatus(data) {
      let a = 0;
      let b = 0;
      let c = 0;
      let d = 0;
      let e = 0;
      let f = 0;
      for (let i = 0; data.length > i; i++) {
        if (data[i].status == '待确认') {
          a++;
        } else if (data[i].status == '已预约') {
          b++;
        } else if (data[i].status == '到点超时') {
          c++;
        } else if (data[i].status == '已开单') {
          d++;
        } else if (data[i].status == '待结算' || data[i].status == '已结算') {
          e++;
        } else {
          f++;
        }
      }
      if (a > 0) return 'two';
      if (b > 0) return 'three';
      if (c > 0) return 'five';
      if (d > 0) return 'one';
      if (e > 0) return 'four';
      if (f > 0) return 'six';
    },
    clickDate(val) {
      this.chooseDateVal = val;
      this.is_submit = false;
      this.pageNum = 1;
      this.getTable();
    },
    chooseTimeSpan(val) {
      this.timeSpan = val;
      this.is_submit = false;
      this.pageNum = 1;
      this.getTable();
    },
    // 多个预约的预约详情
    bespeakDetails(data) {
      this.bespeakDetailsDialog = true;
      this.chooseData = data;
      this.chooseDate = data[0].bookTime;
      this.chooseTechnicianName = data[0].technicianName;
    },
    // 预约详情
    bespeakDetailsTwo(id) {
      if (this.Lib.checkPower('beauty-2-ckyy3') == false) return;
      this.detailsVisible = true;
      getBookOrderDetail({ orderId: id }).then((res) => {
        if (res.code == 0) {
          this.detailsInfo = res.data;
        } else {
          console.log(res);
        }
      });
    },
    // hover进入事件
    hoverMouseover(val, index, n, item) {
      if (this.irreducibleStatus || n == 1) return;
      this.mouseStatus = 2;
      this.mouseVal = val;
      this.mouseIndex = index;
      $(`#${val}${index} span`).text('+新增预约');
      if (item.bookOrderTimeDTOS[index].isLeave == 1) {
        $(`#${val}${index} samp`).text('(该员工休息)');
      }
    },
    // hover离开事件
    hoverMouseout(val, index) {
      if (this.irreducibleStatus) return;
      this.mouseStatus = 2;
      this.mouseVal = val;
      this.mouseIndex = index;
      $(`#${val}${index} span`).text('');
      $(`#${val}${index} samp`).text('');
    },
    arraySpanMethod({
      row, column, columnIndex
    }) {
      if (column.label === '姓名/日期') {
        return;
      }
      if (row.peopleNum == 0) return;
      row.bookInterval = 15;
      if (row.bookOrderTimeDTOS[columnIndex - 1].bookOrderDtailsDTOS.length > 0) {
        if (columnIndex % (row.bookInterval / (this.timeSpan * 1)) === 0) {
          return [1, row.bookInterval / (this.timeSpan * 1)];
        }
        return [0, 0];
      }
      // if (columnIndex % 4 === 0) {
      //     if (row.bookOrderTimeDTOS[columnIndex - 1].bookOrderDtailsDTOS.length > 0) {
      //         // console.log(columnIndex)
      //         return [1, 2]
      //     }
      // } else {
      //     return [0, 0]
      // }
    },
    // socket回调监听
    callback(data) {
      if (data.code == 0) {
        const date = data.data.timeStart.substring(0, 10);
        this.socketStartTime = data.data.timeStart.substring(11, 16);
        this.socketTechnicianId = data.data.technicianId;
        this.chooseTime = date;
        this.pageNum = 1;
        this.getTable();
      }
    },
    // 保存设置不可约
    saveSet() {
      this.chooseNoBook.forEach((a) => {
        const arr = [];
        a.noBookSetTimeList.forEach((b) => {
          if (b.irreducible === 1 || b.noBookItemId) {
            arr.push(b);
          }
        });
        a.noBookSetTimeList = arr;
      });
      batchSetNoBookTime(this.chooseNoBook).then((res) => {
        if (res.code == 0) {
          this.is_submit = false;
          this.pageNum = 1;
          this.irreducibleStatus = false;
          this.chooseNoBook = [];
          this.getTable();
        } else {
          console.log(res);
        }
      });
    },
    // 取消设置不可约
    cancelSet() {
      this.chooseNoBook = [];
      this.irreducibleStatus = false;
      this.is_submit = false;
      this.pageNum = 1;
      this.getTable();
    },
    // 新增预约--跳转
    addBespeak(id, name, item, val, index) {
      const vm = this;
      if (vm.irreducibleStatus) {
        const status = vm.tableData[val].bookOrderTimeDTOS[index].irreducible;
        status == 1 ? vm.tableData[val].bookOrderTimeDTOS[index].irreducible = 0 : vm.tableData[val].bookOrderTimeDTOS[index].irreducible = 1;
        let num = 0;
        vm.$refs.bespeak_table.doLayout();
        if (vm.tableData[val].bookOrderTimeDTOS[index].irreducible == 1) {
          vm.chooseNoBook.forEach((a) => {
            if (a.technicianId === vm.tableData[val].technicianId) {
              let newNum = 0;
              a.noBookSetTimeList.forEach((b) => {
                if (b.timeStart === vm.tableData[val].bookOrderTimeDTOS[index].beginTime) {
                  b.irreducible = 1;
                  b.noBookItemId = vm.tableData[val].bookOrderTimeDTOS[index].noBookItemId;
                  b.timeEnd = vm.tableData[val].bookOrderTimeDTOS[index].endTime;
                  b.timeStart = vm.tableData[val].bookOrderTimeDTOS[index].beginTime;
                } else {
                  newNum++;
                }
              });
              if (a.noBookSetTimeList.length === newNum) {
                const obj = {};
                obj.irreducible = 1;
                obj.noBookItemId = vm.tableData[val].bookOrderTimeDTOS[index].noBookItemId;
                obj.timeEnd = vm.tableData[val].bookOrderTimeDTOS[index].endTime;
                obj.timeStart = vm.tableData[val].bookOrderTimeDTOS[index].beginTime;
                a.noBookSetTimeList.push(obj);
              }
            } else {
              num++;
            }
          });
          if (vm.chooseNoBook.length === num) {
            const obj = {};
            obj.noBookId = vm.tableData[val].noBookId;
            obj.noBookSetTimeList = [];
            obj.mainId = sessionStorage.getItem('mainId');
            obj.scheduleTime = vm.chooseTime;
            obj.technicianId = vm.tableData[val].technicianId;
            const objTwo = {};
            objTwo.irreducible = 1;
            objTwo.noBookItemId = vm.tableData[val].bookOrderTimeDTOS[index].noBookItemId;
            objTwo.timeEnd = vm.tableData[val].bookOrderTimeDTOS[index].endTime;
            objTwo.timeStart = vm.tableData[val].bookOrderTimeDTOS[index].beginTime;
            obj.noBookSetTimeList.push(objTwo);
            vm.chooseNoBook.push(obj);
          }
        } else {
          vm.chooseNoBook.forEach((a) => {
            if (a.technicianId === vm.tableData[val].technicianId) {
              let newNum = 0;
              a.noBookSetTimeList.forEach((b) => {
                if (b.timeStart === vm.tableData[val].bookOrderTimeDTOS[index].beginTime) {
                  b.irreducible = 0;
                  b.noBookItemId = vm.tableData[val].bookOrderTimeDTOS[index].noBookItemId;
                  b.timeEnd = vm.tableData[val].bookOrderTimeDTOS[index].endTime;
                  b.timeStart = vm.tableData[val].bookOrderTimeDTOS[index].beginTime;
                } else {
                  newNum++;
                }
              });
              if (a.noBookSetTimeList.length === newNum) {
                const obj = {};
                obj.irreducible = 1;
                obj.noBookItemId = vm.tableData[val].bookOrderTimeDTOS[index].noBookItemId;
                obj.timeEnd = vm.tableData[val].bookOrderTimeDTOS[index].endTime;
                obj.timeStart = vm.tableData[val].bookOrderTimeDTOS[index].beginTime;
                a.noBookSetTimeList.push(obj);
              }
            } else {
              num++;
            }
          });
          if (vm.chooseNoBook.length === num) {
            const obj = {};
            obj.noBookId = vm.tableData[val].noBookId;
            obj.noBookSetTimeList = [];
            obj.mainId = sessionStorage.getItem('mainId');
            obj.scheduleTime = vm.chooseTime;
            obj.technicianId = vm.tableData[val].technicianId;
            const objTwo = {};
            objTwo.irreducible = 0;
            objTwo.noBookItemId = vm.tableData[val].bookOrderTimeDTOS[index].noBookItemId;
            objTwo.timeEnd = vm.tableData[val].bookOrderTimeDTOS[index].endTime;
            objTwo.timeStart = vm.tableData[val].bookOrderTimeDTOS[index].beginTime;
            obj.noBookSetTimeList.push(objTwo);
            vm.chooseNoBook.push(obj);
          }
        }
        vm.$forceUpdate();
      } else {
        if (vm.tableData[val].bookOrderTimeDTOS[index].irreducible == 1) return;
        window.sessionStorage.bespeakId = '';
        if (id) {
          vm.$router.push({
            name: 'stage-bespeakTechnician',
            params: {
              id,
              name
            }
          });
        } else {
          vm.$router.push({
            name: 'stage-bespeakService'
          });
        }
      }
    },
    // 详情里面新增预约
    detailAddBespeak() {
      const vm = this;
      if (vm.chooseData[0].technicianId) {
        vm.$router.push({
          name: 'stage-bespeakTechnician',
          params: {
            id: vm.chooseData[0].technicianId,
            name: vm.chooseData[0].technicianName
          }
        });
      } else {
        vm.$router.push({
          name: 'stage-bespeakService'
        });
      }
    },
    // 获取当天预约列表数据
    getTable(val) {
      if (val == 'choose') {
        this.chooseDateVal = null;
        this.is_submit = false;
        this.pageNum = 1;
      }
      if (!this.is_submit) {
        this.is_submit = true;
      } else {
        return false;
      }
      if (this.chooseDateVal == 0) {
        this.chooseTime = dayjs().format('YYYY-MM-DD');
      } else if (this.chooseDateVal == 1) {
        this.chooseTime = dayjs().add(1, 'day').format('YYYY-MM-DD');
      } else if (this.chooseDateVal == 2) {
        this.chooseTime = dayjs().add(2, 'day').format('YYYY-MM-DD');
      }
      this.loading = true;
      const data = {
        date: this.chooseTime,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.pageNum,
        pageSize: 6,
        bookInterval: this.timeSpan
      };
      getBookOrders(data).then((res) => {
        if (res.code == 0) {
          this.is_submit = false;
          if (this.pageNum == 1) {
            this.tableData = [];
            this.timeList = res.data.records[0].bookOrderTimeDTOS;
            const duration = this.timeInterval(res.data.records[0].bookOrderTimeDTOS[0].beginTime, res.data.records[0].bookOrderTimeDTOS[0].endTime);
            const arr = [];
            res.data.records.forEach((a) => {
              a.bookOrderTimeDTOS.forEach((b) => {
                if (b.noBookItemId) {
                  b.irreducible = 1;
                }
              });
              arr.push(a);
            });
            this.tableData = JSON.parse(JSON.stringify(arr));
            if (this.socketStartTime) {
              $('#bespeakTable .el-table__body-wrapper').scrollLeft(((this.socketStartTime.substring(0, 2) * 60) + (this.socketStartTime.substring(3, 5) * 1)) / duration[0] * 172 - duration[1]);
              res.data.records.forEach((item, index) => {
                if (item.technicianId == this.socketTechnicianId) {
                  setTimeout(() => {
                    $('#bespeakTable .el-table__body-wrapper').scrollTop(104 * index);
                  }, 300);
                }
              });
            } else {
              const newTime = (this.Lib.G(1, 'yyyy-MM-dd HH:mm')).substring(11, 16);
              const leftWidth = (newTime.substring(0, 2) * 60 + parseInt(newTime.substring(3, 5) / duration[0], 10) * duration[0]) / duration[0] * 172 - duration[1];
              setTimeout(() => {
                $('#bespeakTable .el-table__body-wrapper').scrollLeft(leftWidth);
              }, 300);
            }
            this.socketStartTime = '';
          } else {
            res.data.records.forEach((x) => {
              x.bookOrderTimeDTOS.forEach((y) => {
                if (y.noBookItemId) {
                  y.irreducible = 1;
                }
              });
              this.tableData.push(x);
            });
          }

          if (res.data.current == res.data.pages) {
            this.is_submit = true;
          } else {
            this.pageNum += 1;
          }
          this.loading = false;
        } else {
          console.log(res);
        }
      });
    },
    // 计算时间间隔和需要扣除的水平距离
    timeInterval(start, end) {
      const time = ((end.substring(0, 2) * 60 + end.substring(3, 5) * 1) - (start.substring(0, 2) * 60 + start.substring(3, 5) * 1));
      const width = (start.substring(0, 2) * 60 + start.substring(3, 5) * 1) / time * 172;
      return [time, width];
    },
    // 值小于10的时候，前面加零
    getTwo(val) {
      return val < 10 ? `0${val}` : `${val}`;
    },
    // 获取当天时间每隔十五分钟的数组
    // getTimeList(val) {
    //     var d = new Date("2077/01/01 00:00");
    //     var arr = [];
    //     for (var i = 0; i < 1440 / val; i++) {
    //         var start =
    //             this.getTwo(d.getHours()) +
    //             ":" +
    //             this.getTwo(d.getMinutes());
    //         d.setMinutes(d.getMinutes() + val);
    //         var end =
    //             this.getTwo(d.getHours()) +
    //             ":" +
    //             this.getTwo(d.getMinutes());
    //         var obj = {};
    //         obj.time = start + "-" + end;
    //         arr.push(obj);
    //     }
    //     this.timeList = arr;
    //     this.getTable();
    // },
    handleCommand(val) {
      if (val.name == '开单') {
        if (this.Lib.checkPower('beauty-2-yykd') == false) return;
        this.openBill(val.item.bookOrderId);
      } else if (val.name == '修改') {
        if (this.Lib.checkPower('beauty-2-xgyy') == false) return;
        this.editBespeak(val.item.bookOrderId, val.item.technicianName);
      } else if (val.name == '结算') {
        if (this.Lib.checkPower('beauty-2-yyjs') == false) return;
        this.settlementOrder(val.item.orderId);
      } else if (val.name == '确认') {
        if (this.Lib.checkPower('beauty-2-yyxxqr') == false) return;
        this.cancelBespeak(val.item.bookOrderId, 1);
      } else if (val.name == '拒绝') {
        if (this.Lib.checkPower('beauty-2-yyxxqr') == false) return;
        this.cancelBespeak(val.item.bookOrderId, 0);
      } else {
        if (this.Lib.checkPower('beauty-2-qxyy') == false) return;
        this.cancelBespeak(val.item.bookOrderId, 2);
      }
    },
    // 待确认状态修改  1是确认  0是拒绝
    isConfirm() {
      const data = {
        orderId: this.chooseId,
        type: this.diaStatus
      };
      getSureOrFalse(data).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: this.diaStatus == 1 ? '确认成功' : '拒绝成功',
            type: 'success'
          });
          this.bespeakDetailsDialog = false;
          this.dialogVisible = false;
          this.detailsVisible = false;
          this.getTable('choose');
        } else {
          this.$message(res.msg);
        }
      });
    },
    // 开单
    openBill(id) {
      window.sessionStorage.editOrderId = '';
      window.sessionStorage.bookOrderId = id;
      this.$router.push({
        name: 'stage-serviceBilling'
      });
    },
    // 修改预约
    editBespeak(id, source) {
      window.sessionStorage.bespeakId = id;
      if (source) {
        this.$router.push({
          name: 'stage-bespeakTechnician'
        });
      } else {
        this.$router.push({
          name: 'stage-bespeakService'
        });
      }
    },
    // 结算
    settlementOrder(id) {
      window.sessionStorage.settlementOrderId = id;
      this.$router.push({
        name: 'stage-orderSettlement',
      });
    },
    // 取消预约
    cancelBespeak(id, val) {
      if (val === 2) {
        getBookCancelMsg({ id }).then((res) => {
          if (res.code == 0) {
            this.chooseId = id;
            this.cancelStatus = res.data ? res.data.cancelStatus ? 1 : 0 : 0;
            this.diaStatus = val;
            this.dialogVisible = true;
          } else {
            console.log(res);
          }
        });
      } else if (val === 0) {
        this.chooseId = id;
        this.diaStatus = val;
        this.cancelStatus = 1;
        this.dialogVisible = true;
      } else {
        this.chooseId = id;
        this.diaStatus = val;
        this.cancelStatus = 1;
        this.isConfirm();
      }
    },
    // 确定取消预约
    comfirmCancelBespeak() {
      if (this.diaStatus === 2) {
        const data = {
          id: this.chooseId
        };
        getBookFailures(data).then((res) => {
          if (res.code == 0) {
            this.$message({ message: '取消成功', type: 'success' });
            this.dialogVisible = false;
            this.detailsVisible = false;
            this.bespeakDetailsDialog = false;
            this.getTable('choose');
          } else {
            this.$message(res.msg);
          }
        });
      } else {
        this.isConfirm();
      }
    },
    returnBookingData(scope) {
      if (scope.row.bookOrderTimeDTOS.length > 0) {
        return scope.row.tableMap[scope.column.label];
      }
    }
  }
};
</script>
<style lang="less" scoped>
.textShow {
  width: 172px;
  padding: 0 10px;
  overflow: hidden;
  white-space: pre-line;
  line-height: 18px;
}
.screen {
  color: #999;
  font-size: 20px;
  cursor: pointer;
  float: right;
  position: relative;
  z-index: 1;
  margin-top: -48px;
}
.orderStatus {
  height: 20px;
  line-height: 20px;
  margin: 5px 0 20px 0;
  p {
    padding-right: 20px;
    font-size: 12px;
    line-height: 20px;
    float: left;
    span {
      display: block;
      float: left;
      width: 36px;
      height: 20px;
    }
    label {
      display: block;
      float: left;
      padding-left: 10px;
    }
  }
  // p:nth-child(1) span {
  //   background-color: #eaf6ff;
  // }
  // p:nth-child(1) label {
  //   color: #50b4ff;
  // }
  p:nth-child(1) span {
    background-color: #e3f9fa;
  }
  p:nth-child(1) label {
    color: #26c6ce;
  }
  p:nth-child(2) span {
    background-color: #fcf6e8;
  }
  p:nth-child(2) label {
    color: #ffb64f;
  }
  p:nth-child(3) span {
    background-color: #fef0f1;
  }
  p:nth-child(3) label {
    color: #ff6a75;
  }
  p:nth-child(4) span {
    background-color: #f0f9eb;
  }
  p:nth-child(4) label {
    color: #83c85d;
  }
  p:nth-child(5) span {
    background-color: #f8f8f8;
  }
  p:nth-child(5) label {
    color: #a7a7a7;
  }
  p:nth-child(6) span {
    background: linear-gradient(
      -45deg,
      #cdcdcd 0,
      #cdcdcd 10%,
      transparent 10%,
      transparent 50%,
      #cdcdcd 50%,
      #cdcdcd 60%,
      transparent 60%,
      transparent
    );
    background-size: 6px 6px;
  }
  p:nth-child(6) label {
    color: #a7a7a7;
  }
}
.orderFoot {
  position: fixed;
  margin-left: -30px;
  bottom: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #ffffff;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  i {
    font-family: "iconfont";
    font-size: 20px;
    padding-left: 30px;
    display: block;
    float: left;
    cursor: pointer;
  }
  span {
    font-size: 14px;
    padding-left: 10px;
    display: block;
    float: left;
    cursor: pointer;
  }
  samp {
    font-size: 14px;
    color: #999;
    padding-left: 20px;
  }
}
.customer {
  width: 100%;
  height: 104px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; /*加宽度width属来兼容部分浏览*/
  // padding:5px;
}
.customer_box {
  width: 100%;
  height: 104px;
  line-height: 104px;
  cursor: pointer;
  .span {
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    border-radius: 50%;
  }
  .one {
    color: #50b4ff;
    background-color: #eaf6ff;
    span {
      background-color: #50b4ff;
      color: #fff;
    }
  }
  .two {
    color: #26c6ce;
    background-color: #e3f9fa;
    span {
      background-color: #26c6ce;
      color: #fff;
    }
  }
  .three {
    background-color: #fcf6e8;
    color: #ffb64f;
    span {
      background-color: #ffb64f;
      color: #fff;
    }
  }
  .four {
    background-color: #f0f9eb;
    color: #83c85d;
    span {
      background-color: #83c85d;
      color: #fff;
    }
  }
  .five {
    background-color: #fef0f1;
    color: #ff6a75;
    span {
      background-color: #ff6a75;
      color: #fff;
    }
  }
  .six {
    background-color: #f8f8f8;
    color: #a7a7a7;
    span {
      background-color: #a7a7a7;
      color: #fff;
    }
  }
}
.addBespeakHover:hover {
  background-color: #fef0f1;
  color: #ff6a75;
  cursor: pointer;
}
.addBespeakHover span {
  display: block;
  height: 52px;
  line-height: 104px;
}
.addBespeakHover samp {
  display: block;
  height: 52px;
  line-height: 39px;
}
.bespeakDetails {
  padding: 20px;
  h1 {
    font-size: 16px;
    color: #333;
    height: 18px;
    line-height: 18px;
    padding-bottom: 20px;
  }
  ul {
    padding: 10px 0 10px 20px;
    clear: both;
    height: 170px;
    list-style-type: none;
    background-color: #f5f5f5;
    li {
      width: 100%;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      color: #333;
      p {
        width: 192.5px;
        float: left;
        padding-right: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .bespeakBtn {
    height: 40px;
    padding-top: 20px;
    clear: both;
  }
}

.newNum {
  background: linear-gradient(
    -30deg,
    rgba(205, 205, 205, 0.5) 0,
    rgba(205, 205, 205, 0.5) 5%,
    transparent 5%,
    transparent 50%,
    rgba(205, 205, 205, 0.5) 50%,
    rgba(205, 205, 205, 0.5) 55%,
    transparent 55%,
    transparent
  );
  background-size: 32px 18px;
}.yyTop {
  background-color: #F5F7FA;
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  i {
    font-weight: 100;
    position: relative;
    top: 2px;
    font-size: 20px;
    font-weight: bold;
  }
  span {
    font-size: 18px;
    font-weight: bold;
    padding-left: 5px;
  }
  samp {
    font-size: 14px;
    color: #FA5555;
    float: right;
  }
}
.yyInfoTitle {
  padding: 20px 20px 0 20px;
  .sl {
    float: left;
    width: 5px;
    height: 15px;
    background-color: #409EFF;
    border-radius: 4px;
    position: relative;
    top: 2px;
    margin-right: 5px;
  }
  .sm {
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
}
.yyInfo {
  display: table;
  p {
    display: flex;
    padding-top: 20px;
    line-height: 16px;
    font-size: 14px;
    span {
      width: 90px;
      float: left;
      text-align: right;
      color: #666;
    }
    samp {
      flex: 1;
      padding-right: 20px;
      padding-right: 20px;
      color: #000;
    }
  }
  h5 {
    width: 560px;
    padding-top: 20px;
    line-height: 16px;
    font-size: 14px;
    span {
      width: 90px;
      float: left;
      text-align: right;
      color: #666;
    }
    samp {
      color: #000;
    }
    label {
      cursor: pointer;
      float: right;
      color: #409EFF;
    }
    i {
      cursor: pointer;
      float: right;
      color: #409EFF;
      padding: 0 20px 0 5px;
      position: relative;
      top: 1px;
    }
  }
}
.yyFoot {
  padding: 20px;
  float: right;
}
</style>
<style>
.yyDetails .el-dialog .el-dialog__body {
  padding: 0;
}
.bespeakFive td {
  padding: 0 !important;
}
.bespeakFive th {
  padding: 0 !important;
}
.bespeakFive .cell {
  padding: 0 !important;
}
.bespeakFive .el-dropdown {
  width: 100%;
}
</style>
